var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-per"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('input',{attrs:{"type":"number"},domProps:{"value":_vm.value},on:{"input":_vm.inputChange}}),_c('div',[_vm._v("单位／秒")])])}
var staticRenderFns = []

export { render, staticRenderFns }